import { tokenStorage } from '../auth/tokenStorage';

const AUTH_FREE_PATHS = ['/Staff/auth/login', '/staff/auth/refresh'];

export function requestInterceptor(config) {
  const url = (config.url || '').toLowerCase();
  const isAuthFree = AUTH_FREE_PATHS.some((p) => url.includes(p.toLowerCase()));
  const token = tokenStorage.getAccessToken();
  const hasBasicAuth = config.headers?.Authorization?.startsWith('Basic ');
  if (token && !isAuthFree && !hasBasicAuth) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
    config.headers.access_token = token;
  }
  return config;
}
